import { FieldProps, TextField, useFieldHelper } from 'framework/ui/field';

const LeaveDurationField = ({ value: inputValue = null, source = null, ...props }: FieldProps) => {
  const { getValue } = useFieldHelper<any>({ value: inputValue, source });
  const duration = getValue();
  let value = '';

  if (duration) {
    const postfix = duration > 1 ? 'days' : 'day';
    value = `${duration} ${postfix}`;
  }

  return <TextField value={value} source={source} {...props} />;
};

export default LeaveDurationField;
